// Shared between StatusSettings (post-creation status editor) and the Create Form wizard
// (status template preview at creation time) so both present the exact same set of templates.

// Values used by system actions (Escalate, Mark Resolved, Re-Open). These statuses cannot be
// deleted — only renamed and recoloured — because the ticket state machine depends on them.
export const SYSTEM_STATUS_VALUES = new Set(['reported', 'open', 'resolved', 'reopened', 'escalated']);

export const STATUS_TEMPLATES = [
    {
        id: 'default',
        name: 'Default',
        description: 'Standard 5-stage flow for general support tickets',
        statuses: [
            { id: 0, title: 'Reported',  value: 'reported',  color: '#7F78FF' },
            { id: 1, title: 'Open',      value: 'open',      color: '#7ECA43' },
            { id: 2, title: 'Resolved',  value: 'resolved',  color: '#2784B9' },
            { id: 3, title: 'Re-Opened', value: 'reopened',  color: '#FF8628' },
            { id: 4, title: 'Escalated', value: 'escalated', color: '#FB392D' },
        ],
    },
    {
        id: 'customer_support',
        name: 'Customer Support',
        description: 'Acknowledgement-oriented flow for customer-facing forms',
        statuses: [
            { id: 0, title: 'Submitted',    value: 'reported',  color: '#7F78FF' },
            { id: 1, title: 'Acknowledged', value: 'open',      color: '#40c47d' },
            { id: 2, title: 'In Review',    value: 'in_review', color: '#FDB16C' },
            { id: 3, title: 'Resolved',     value: 'resolved',  color: '#2784B9' },
            { id: 4, title: 'Re-Opened',    value: 'reopened',  color: '#FF8628' },
            { id: 5, title: 'Escalated',    value: 'escalated', color: '#FB392D' },
        ],
    },
    {
        id: 'bug_tracking',
        name: 'Bug Tracking',
        description: 'For software issues with triage and verification stages',
        statuses: [
            { id: 0, title: 'Reported',    value: 'reported',    color: '#7F78FF' },
            { id: 1, title: 'Confirmed',   value: 'open',        color: '#FDB16C' },
            { id: 2, title: 'In Progress', value: 'in_progress', color: '#40c47d' },
            { id: 3, title: 'Fixed',       value: 'resolved',    color: '#2784B9' },
            { id: 4, title: 'Re-Opened',   value: 'reopened',    color: '#FF8628' },
            { id: 5, title: 'Escalated',   value: 'escalated',   color: '#FB392D' },
        ],
    },
    {
        id: 'it_service',
        name: 'IT Service Desk',
        description: 'SLA-focused flow for IT helpdesk requests',
        statuses: [
            { id: 0, title: 'New',          value: 'reported',  color: '#7F78FF' },
            { id: 1, title: 'Assigned',     value: 'open',      color: '#40c47d' },
            { id: 2, title: 'Pending User', value: 'pending',   color: '#FDB16C' },
            { id: 3, title: 'Resolved',     value: 'resolved',  color: '#2784B9' },
            { id: 4, title: 'Re-Opened',    value: 'reopened',  color: '#FF8628' },
            { id: 5, title: 'Escalated',    value: 'escalated', color: '#FB392D' },
        ],
    },
    {
        id: 'hr_feedback',
        name: 'HR / Feedback',
        description: 'For internal HR requests and employee feedback',
        statuses: [
            { id: 0, title: 'Submitted',       value: 'reported',     color: '#7F78FF' },
            { id: 1, title: 'Under Review',    value: 'open',         color: '#9a60b0' },
            { id: 2, title: 'Action Required', value: 'action_reqd',  color: '#FDB16C' },
            { id: 3, title: 'Responded',       value: 'resolved',     color: '#2784B9' },
            { id: 4, title: 'Re-Opened',       value: 'reopened',     color: '#FF8628' },
            { id: 5, title: 'Escalated',       value: 'escalated',    color: '#FB392D' },
        ],
    },
    {
        id: 'simple',
        name: 'Simple',
        description: 'Minimal open to closed flow for lightweight forms',
        statuses: [
            { id: 0, title: 'Open',        value: 'reported',  color: '#7ECA43' },
            { id: 1, title: 'In Progress', value: 'open',      color: '#FDB16C' },
            { id: 2, title: 'Closed',      value: 'resolved',  color: '#2784B9' },
            { id: 3, title: 'Re-Opened',   value: 'reopened',  color: '#FF8628' },
            { id: 4, title: 'Escalated',   value: 'escalated', color: '#FB392D' },
        ],
    },
];
